import * as React from 'react';
export const SvgFiletypeMicrostation = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#548ec7' }),
        React.createElement("path", { d: 'M10.747 12.35a6.255 6.255 0 01-1.35-3.402C7.856 11.32 6.7 11.526 6.025 10.392L5.253 14H4l2.024-8.866 1.06-.206c.097 0-.867 3.917.29 4.33S10.071 4 10.071 4l1.253.206c-.867 2.371-.964 4.742.675 6.907z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#3d648a' })));
};
export default SvgFiletypeMicrostation;
